import React, { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const ProtectedRoute = () => {
  const [userAllow, setUserAllow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkAuthorization = () => {
      const urlParams = new URLSearchParams(window.location.search);

      // Method 0: Check for userToken parameter in URL (when redirected with a session token)
      const userTokenParam = urlParams.get("userToken");

      if (userTokenParam) {
        localStorage.setItem("authToken", userTokenParam);

        // Remove userToken from URL for security
        const url = new URL(window.location.href);
        url.searchParams.delete("userToken");
        window.history.replaceState({}, document.title, url.pathname + url.search);

        setUserAllow(true);
        return;
      }

      // Method 1: Check for token in localStorage
      const authToken = localStorage.getItem("authToken");

      // Method 2: Check referrer to see if coming from oruclicks.com
      const referrer = document.referrer;
      const isFromOruclicks = referrer && referrer.includes("oruclicks.com");

      // Method 3: Check for token parameter in URL (when redirected from support button)
      const tokenParam = urlParams.get("token");

      // If token parameter exists, store it in localStorage
      if (tokenParam) {
        localStorage.setItem("authToken", tokenParam);

        // Remove token from URL for security
        const url = new URL(window.location.href);
        url.searchParams.delete("token");
        window.history.replaceState({}, document.title, url.pathname);

        setUserAllow(true);
        return;
      }

      // Check if user came from oruclicks.com or has valid token
      if (authToken || isFromOruclicks) {
        // If coming from oruclicks.com for the first time, check for token in URL
        if (isFromOruclicks && !authToken) {
          // Try to get token from URL again (might be with different parameter)
          const urlToken =
            tokenParam ||
            new URLSearchParams(window.location.search).get("auth");
          if (urlToken) {
            localStorage.setItem("authToken", urlToken);
          } else {
            // No token provided - redirect to landing page
            navigate("/");

            return;
          }
        }
        setUserAllow(true);
      } else {
        // Not authorized - redirect to landing page

        // navigate("/");
        // Local
        setUserAllow(true);
      }
    };

    checkAuthorization();
  }, [navigate]);

  return userAllow ? <Outlet /> : null; // Show the page only if authorized from oruclicks.com
};

export default ProtectedRoute;
